<template>
  <div
    class="residencesTable"
  >
    <div
      v-for="code of codes"
      :key="`${code}`"
      class="residence"
    >
      <h4>{{ code }} ({{ residences_sorted[code].length }}):</h4>
      <div
        v-for="residence of residences_sorted[code]"
        :key="`${code + '-' + residence.id}`"
        :class="{ open: residence.availability_months.length > 0 }"
      >
        <div>{{ residence.zip_code }}</div>
        <div>{{ residence.city }}</div>
        <a
          :href="residence.url"
          target="_blank"
        > 
          {{ residence.title }}
        </a>
        <residence-offers v-if="residence.availability_months.length > 0" :residence="residence" />
        </div>
      </div>
  </div>
</template>

<script>
import ResidenceOffers from '@/components/residences/ResidenceOffers'

export default {
  name: "ResidencesTable",
  components: {
    ResidenceOffers
  },
  props: {
    residences: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    codes() {
      return Object.keys(this.residences_sorted)
    },
    residences_sorted() {
      const groupBy = {}
      this.residences.forEach(obj => {
        // group by departement
        const code = obj.zip_code.substring(0,2)
        if (groupBy.hasOwnProperty(code)) {
          groupBy[code].push(obj)
        } else {
          groupBy[code] = [obj]
        }
      })
      Object.keys(groupBy).forEach(key => {
        // sort by zip code
        groupBy[key].sort((r1, r2) => r1.zip_code - r2.zip_code)
      })
      return groupBy
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.residencesTable';

#{$c} {
  display: flex;
  flex-direction: column;

  a {
    cursor: pointer;
    text-decoration: underline;
    font-size: 16px;
    color: $--color-text-regular;
  }
  & .residence > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
  }  
  & .residence > div > * {
    margin: 0 1rem;
  }
  & .residence > div a {
    color: $--color-danger;
  }
  & .open a {
    color: $--color-success !important;
  }
}
</style>